import { PageLeaveActionTypesKeys, SetIsPageLeaveAllowed } from '@store/action-types/page-leave-action-types'

export function setIsPageLeaveAllowed(isAllowed: boolean): SetIsPageLeaveAllowed {
  return {
    type: PageLeaveActionTypesKeys.SET_IS_PAGE_LEAVE_ALLOWED,
    payload: isAllowed,
  }
}
